var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 4.5C12.0925 4.5 14.6275 6.0975 15.865 8.625C14.6275 11.1525 12.0925 12.75 9.25 12.75C6.4075 12.75 3.8725 11.1525 2.635 8.625C3.8725 6.0975 6.4075 4.5 9.25 4.5ZM9.25 3C5.5 3 2.2975 5.3325 1 8.625C2.2975 11.9175 5.5 14.25 9.25 14.25C13 14.25 16.2025 11.9175 17.5 8.625C16.2025 5.3325 13 3 9.25 3ZM9.25 6.75C10.285 6.75 11.125 7.59 11.125 8.625C11.125 9.66 10.285 10.5 9.25 10.5C8.215 10.5 7.375 9.66 7.375 8.625C7.375 7.59 8.215 6.75 9.25 6.75ZM9.25 5.25C7.39 5.25 5.875 6.765 5.875 8.625C5.875 10.485 7.39 12 9.25 12C11.11 12 12.625 10.485 12.625 8.625C12.625 6.765 11.11 5.25 9.25 5.25Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eyeOn.ee64939849d7f64a028c91736c5192f3.svg";
export { ForwardRef as ReactComponent };